import { render, staticRenderFns } from "./CospendIcon.vue?vue&type=template&id=cab7d6d2&"
import script from "./CospendIcon.vue?vue&type=script&lang=js&"
export * from "./CospendIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports